module.exports = __webpack_public_path__ + "static/media/epbdegg.5d6b09d0.png";